export const BANNER_SUCCESS = 'BANNER_SUCCESS';
export const BANNER_ERROR = 'BANNER_ERROR';
export const BANNER_LOADING = 'BANNER_LOADING';
